<template>
  <!-- Card 86akp2bkg: com uma solicitação aguardando resposta (entrada em
       turma, turma nova ou experimental), o aluno não faz outra até cancelar
       essa. O aviso diz qual é e oferece o cancelamento ali mesmo. -->
  <div v-if="request" class="oreq" role="status">
    <v-icon size="22" color="#be185d" class="oreq__icon">mdi-timer-sand</v-icon>
    <div class="oreq__body">
      <div class="oreq__title">
        {{ $t("openRequest.title") }}
      </div>
      <p class="oreq__text">
        {{ $t("openRequest.text", { description }) }}
      </p>
    </div>
    <button
      type="button"
      class="oreq__btn"
      :disabled="canceling"
      @click="cancel"
    >
      {{ canceling ? $t("openRequest.canceling") : $t("openRequest.cancel") }}
    </button>
  </div>
</template>

<script>
import { format } from "date-fns";
import customerApi from "@/shared/pitchCustomerApi";

export default {
  name: "OpenRequestNotice",

  props: {
    // { classId, kind: 'trial' | 'new-class' | 'join', cod, teacherName,
    //   trialDate } -- vindo de GET /customers/requests/open.
    request: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      canceling: false,
    };
  },

  computed: {
    description() {
      const { kind, teacherName, cod, trialDate } = this.request || {};
      const teacher = teacherName
        ? this.$t("openRequest.withTeacher", { name: teacherName })
        : "";

      if (kind === "trial") {
        const date = this.formatDate(trialDate);
        return this.$t("openRequest.trial", {
          teacher,
          date: date ? this.$t("openRequest.forDate", { date }) : "",
        });
      }
      if (kind === "new-class") {
        return this.$t("openRequest.newClass", { teacher });
      }
      return this.$t("openRequest.join", { code: cod, teacher });
    },
  },

  methods: {
    formatDate(value) {
      if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return "";
      const [year, month, day] = value.split("-");
      return format(new Date(+year, +month - 1, +day), this.$t("formats.date"));
    },

    async cancel() {
      if (!window.confirm(this.$t("openRequest.confirm"))) {
        return;
      }

      this.canceling = true;
      try {
        const res = await customerApi.cancelRequest(this.request.classId);
        this.$root.$emit("display-alert", {
          text: res.data.message,
          type: 0,
        });
        this.$emit("canceled");
      } catch (err) {
        this.$root.$emit("display-alert", {
          text:
            err?.response?.data?.message || this.$t("openRequest.cancelFailed"),
          type: 1,
        });
        // A solicitação pode ter sido respondida enquanto a tela estava
        // aberta: o pai recarrega e o aviso some ou se atualiza.
        this.$emit("canceled");
      } finally {
        this.canceling = false;
      }
    },
  },
};
</script>

<style lang="css" scoped>
.oreq {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 0 0 18px;
  padding: 14px 18px;
  border: 1px solid rgba(232, 39, 111, 0.3);
  border-radius: 14px;
  background: #fdf2f7;
}
.oreq__icon {
  flex: 0 0 auto;
}
.oreq__body {
  flex: 1 1 auto;
  min-width: 0;
}
.oreq__title {
  font-weight: 700;
  font-size: 0.95rem;
  color: #3b1f2b;
}
.oreq__text {
  margin: 4px 0 0;
  font-size: 0.85rem;
  color: #5b4b54;
}
.oreq__btn {
  flex: 0 0 auto;
  padding: 9px 16px;
  border: 1px solid rgba(232, 39, 111, 0.45);
  border-radius: 12px;
  background: var(--dk-surface, #fff);
  color: var(--dk-pink-deep, #be185d);
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
}
.oreq__btn:hover {
  background: rgba(232, 39, 111, 0.06);
}
.oreq__btn:disabled {
  opacity: 0.6;
  cursor: progress;
}
.oreq__btn:focus-visible {
  outline: 2px solid var(--dk-pink, #e8276f);
  outline-offset: 2px;
}
@media (max-width: 600px) {
  .oreq {
    flex-wrap: wrap;
  }
  .oreq__btn {
    width: 100%;
  }
}
</style>
